import React from "react";
import {Grid, Tooltip} from "@mui/material";
import ToolbarButton from "./ToolbarButton";
import CustomEditor from "../CustomEditor";
import {useSlate} from "slate-react";
import {markTooltips} from "./Tooltips";

export default function MarkButton({format,Icon}){
    const editor = useSlate();
    return <Grid item>
        <Tooltip title={markTooltips[format]} placement={'top'} arrow>
            <ToolbarButton
                variant={CustomEditor.isMarkActive(editor,format)?'contained':'text'} 
                color={CustomEditor.isMarkActive(editor,format)?'primary':'secondary'}
                onMouseDown={(e)=>{
                    e.preventDefault();
                    CustomEditor.toggleMark(editor,format);
                }}
            >
                <Icon/>
            </ToolbarButton>
        </Tooltip>
    </Grid>
}

